const responses = [
    {id: 3, title: 'MCP Get Rate'},
    {id: 4, title: 'MCP Purchase'},
    {id: 5, title: 'MCP Purchase with 3DS'},
    {id: 6, title: 'MCP Purchase with Vault'},
    {id: 7, title: 'MCP Purchase with 3DS and Vault'},
    {id: 8, title: 'MCP Pre-Auth'},
    {id: 9, title: 'MCP Pre-Auth with 3DS'},
    {id: 10, title: 'MCP Pre-Auth with Vault'},
    {id: 11, title: 'MCP Pre-Auth with 3DS and Vault'},
    {id: 12, title: 'MCP Pre-Auth Completion'},
    {id: 13, title: 'MCP Purchase Correction'},
    {id: 14, title: 'MCP Refund'},
    {id: 15, title: 'MCP Independent Refund'},
    {id: 16, title: 'MCP Independent Refund with Vault'},
]

export default responses